module.exports = __webpack_public_path__ + "static/media/balanceToledo.8b41a4cd.svg";